module.exports = __webpack_public_path__ + "img/41.9caf5705.webp";